// extracted by mini-css-extract-plugin
export var text = "_aw-0";